module.exports = __webpack_public_path__ + "img/vert.9df45479.png";